"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cairate": {
    "40aee8f1": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "skipSearch": false
    }],
    "allodola": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d7a7e14": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-bianchi": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43957a6e": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-cattaneo": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "940d9dbc": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "skipSearch": false
    }],
    "roncaccio": [{
      "hkey": "62f0b4e2",
      "slug": "cairate",
      "name": "Cairate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;